export function uniqueElementsInArray<T>(array: T[]): T[] {
	return Array.from(new Set(array));
}
